module.exports = __webpack_public_path__ + "img/banner-princiapal.2f23f585.svg";